import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const DRAWER_DEFAULT_WIDTH = 320;
export const DRAWER_MIN_WIDTH = 200;
export const DRAWER_MAX_WIDTH = 480;
const clampWidth = value => {
  if (Number.isNaN(value)) return DRAWER_DEFAULT_WIDTH;
  if (value < DRAWER_MIN_WIDTH) return DRAWER_MIN_WIDTH;
  if (value > DRAWER_MAX_WIDTH) return DRAWER_MAX_WIDTH;
  return value;
};
export const useDrawerPersistence = create()(persist(set => ({
  open: true,
  width: DRAWER_DEFAULT_WIDTH,
  setOpen: open => set({
    open
  }),
  toggleOpen: () => set(state => ({
    open: !state.open
  })),
  setWidth: width => set({
    width: clampWidth(width)
  })
}), {
  name: 'academy-ai-assistant-drawer'
}));